export default __webpack_public_path__ + "static/media/cpp.666af1b3.png";